const declarationTypes = {
	DECLARE: 'DECLARE',
	PASS: 'PASS',
	COINCHE: 'COINCHE',
	SURCOINCHE: 'SURCOINCHE',
};

export default declarationTypes;